import { Pipe, PipeTransform } from '@angular/core';
import { FormItem } from '../_models/formitem';


@Pipe({
    name: 'FormFilter',
    standalone: false
})
export class FormFilterPipe implements PipeTransform {

  transform(items: FormItem[], searchText: string): any {
    if (!items) {
      return [];
    }
    if (!searchText) {
      return items;
    }
    searchText = searchText.toLocaleLowerCase();

    return items.filter(it => {
      return it.description.toLocaleLowerCase().includes(searchText) ||
      it.title.toLocaleLowerCase().includes(searchText);
    });

  }

}
